import { FC } from "react";

export const SearchIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_932_6485)">
        <path
          d="M19.7559 18.5778L14.7817 13.6036C16.1372 11.9458 16.8037 9.83038 16.6433 7.69494C16.4828 5.5595 15.5077 3.56742 13.9197 2.13074C12.3317 0.694065 10.2522 -0.0772832 8.11143 -0.0237567C5.97064 0.0297698 3.93232 0.904076 2.41807 2.41832C0.903832 3.93256 0.0295257 5.97088 -0.0240008 8.11167C-0.0775273 10.2525 0.693821 12.3319 2.1305 13.92C3.56717 15.508 5.55926 16.4831 7.6947 16.6435C9.83014 16.804 11.9456 16.1375 13.6034 14.782L18.5776 19.7561C18.7347 19.9079 18.9452 19.9919 19.1637 19.99C19.3822 19.9881 19.5912 19.9005 19.7457 19.746C19.9003 19.5915 19.9879 19.3825 19.9898 19.164C19.9917 18.9455 19.9077 18.735 19.7559 18.5778ZM8.3334 15.0003C7.01485 15.0003 5.72592 14.6093 4.62959 13.8768C3.53327 13.1442 2.67878 12.103 2.1742 10.8849C1.66961 9.66669 1.53759 8.32624 1.79483 7.03304C2.05206 5.73983 2.687 4.55194 3.61935 3.61959C4.5517 2.68724 5.73959 2.05231 7.03279 1.79507C8.326 1.53784 9.66644 1.66986 10.8846 2.17444C12.1028 2.67903 13.144 3.53351 13.8765 4.62984C14.6091 5.72617 15.0001 7.0151 15.0001 8.33364C14.9981 10.1011 14.2951 11.7957 13.0452 13.0455C11.7954 14.2953 10.1009 14.9983 8.3334 15.0003Z"
          fill="#6C757D"
        />
      </g>
      <defs>
        <clipPath id="clip0_932_6485">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
